<div class="d-flex flex-column gap-2">
  @for (view of viewSteps(); track $index) {
    <div class="plan-step mat-border-subtle mat-corner-md overflow-hidden">
      <div class="plan-step__header mat-bg-surface-container-low">
        <span
          class="plan-step__number d-inline-flex align-items-center justify-content-center mat-corner-full mat-font-label-md"
        >
          {{ view.number }}
        </span>
        <div>
          <div class="mat-font-body-md fw-medium">{{ view.step.text }}</div>
          @if (view.step.meta) {
            <div class="mat-font-label-sm mat-text-on-surface-variant">{{ view.step.meta }}</div>
          }
        </div>
        <div class="d-flex flex-column align-items-end gap-1">
          @if (view.showBadge) {
            <app-confidence-badge [value]="view.confidence" />
          }
          <mat-icon class="mat-icon-sm" [class]="view.aggregateToneClass" [matTooltip]="view.aggregateTooltip">
            {{ view.aggregateIcon }}
          </mat-icon>
        </div>
      </div>
      @for (task of view.tasks; track task.task.text) {
        <div class="plan-task-row">
          <mat-icon class="mat-icon-sm plan-task-row__lead" aria-hidden="true">subdirectory_arrow_right</mat-icon>
          <span class="mat-font-body-sm">{{ task.task.text }}</span>
          <div class="d-flex flex-column align-items-end gap-1">
            <mat-icon class="mat-icon-sm" [class]="task.toneClass" [matTooltip]="task.tooltip">
              {{ task.icon }}
            </mat-icon>
            @if (task.attempts !== null) {
              <span
                class="plan-task-row__attempts d-inline-flex align-items-center gap-1 mat-font-label-sm mat-text-on-surface-variant"
                [title]="task.attemptsTooltip"
              >
                <mat-icon class="mat-icon-xs" aria-hidden="true">replay</mat-icon>
                <span>{{ task.attempts }}</span>
              </span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>